var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuizEmptyState = function SvgQuizEmptyState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 263,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.002 238.283c54.868 0 99.347-44.479 99.347-99.346 0-54.868-44.479-99.347-99.347-99.347-54.867 0-99.346 44.48-99.346 99.347s44.479 99.346 99.346 99.346Z",
    fill: "url(#quiz-empty-state_svg__a)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#quiz-empty-state_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.437 73.37H86.359a22.52 22.52 0 0 0-22.52 22.519v90.078a22.519 22.519 0 0 0 22.52 22.519h90.078a22.522 22.522 0 0 0 22.519-22.519V95.889a22.52 22.52 0 0 0-22.519-22.52Zm-12.761 49.617-34.305 45.039a7.502 7.502 0 0 1-5.93 2.928 7.51 7.51 0 0 1-5.93-2.853l-18.316-23.345a7.515 7.515 0 0 1 11.861-9.233l12.235 15.614 28.375-37.533a7.55 7.55 0 0 1 12.01 9.158v.225Z",
    fill: "url(#quiz-empty-state_svg__c)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M243.999 89.501a12.5 12.5 0 0 1-12.52 12.514h-41.625a16.896 16.896 0 0 1-2.695-.223 15.728 15.728 0 0 1 2.022-31.213 22.155 22.155 0 0 1 42.095 6.409h.189A12.516 12.516 0 0 1 243.999 89.5Z",
    fill: "url(#quiz-empty-state_svg__d)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.336 64.992a9.434 9.434 0 0 0 9.434 9.434h31.32a11.84 11.84 0 0 0 .5-23.666 16.685 16.685 0 0 0-31.672 4.819h-.141a9.434 9.434 0 0 0-9.441 9.413Z",
    fill: "url(#quiz-empty-state_svg__e)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 185.611a12.451 12.451 0 0 0 10.822 12.351c.545.076 1.094.114 1.644.115H77.91a16.787 16.787 0 0 0 2.695-.222 15.67 15.67 0 0 0 13.061-16.471 15.669 15.669 0 0 0-15.083-14.641 22.07 22.07 0 0 0-23.36-12.572 22.066 22.066 0 0 0-18.56 18.953h-.196a12.462 12.462 0 0 0-11.523 7.71 12.466 12.466 0 0 0-.943 4.777Z",
    fill: "url(#quiz-empty-state_svg__f)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M210.768 117.088a1.655 1.655 0 0 1 2.052-2.003l6.432 1.808c1.227.345 1.621 1.888.709 2.778l-4.782 4.667a1.655 1.655 0 0 1-2.76-.776l-1.651-6.474ZM45.178 117.088c-.315-1.235.825-2.348 2.052-2.003l6.433 1.808a1.655 1.655 0 0 1 .708 2.778l-4.782 4.667a1.655 1.655 0 0 1-2.76-.776l-1.65-6.474ZM100.492 31.999c.489-2.027 3.372-2.027 3.862 0l1.129 4.68c.175.724.741 1.29 1.465 1.464l4.68 1.13c2.027.49 2.027 3.372 0 3.862l-4.68 1.13c-.724.174-1.29.74-1.465 1.464l-1.129 4.68c-.49 2.027-3.373 2.027-3.862 0l-1.13-4.68a1.986 1.986 0 0 0-1.465-1.465l-4.68-1.13c-2.026-.489-2.026-3.372 0-3.86l4.68-1.13a1.986 1.986 0 0 0 1.465-1.465l1.13-4.68Z",
    fill: "#A9E0D4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.169 220.411a3.777 3.777 0 1 1-7.554 0 3.777 3.777 0 0 1 7.554 0Z",
    stroke: "#A9E0D4",
    strokeWidth: 2.483
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M209.445 188.985c.489-2.027 3.372-2.027 3.862 0l1.129 4.68a1.987 1.987 0 0 0 1.465 1.464l4.68 1.13c2.027.489 2.027 3.372 0 3.862l-4.68 1.129a1.988 1.988 0 0 0-1.465 1.465l-1.129 4.68c-.49 2.027-3.373 2.027-3.862 0l-1.13-4.68a1.987 1.987 0 0 0-1.464-1.465l-4.68-1.129c-2.027-.49-2.027-3.373 0-3.862l4.68-1.13a1.986 1.986 0 0 0 1.464-1.464l1.13-4.68Z",
    fill: "#A9E0D4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 216.397,
    cy: 163.065,
    r: 3.776,
    stroke: "#5DC0AD",
    strokeOpacity: 0.4,
    strokeWidth: 2.483
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "quiz-empty-state_svg__a",
    x1: 131.237,
    y1: 7.241,
    x2: 133.272,
    y2: 356.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "quiz-empty-state_svg__c",
    x1: 243.995,
    y1: 0.181,
    x2: -119.78,
    y2: 479.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#A4E9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "#257E6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "quiz-empty-state_svg__d",
    x1: 230.735,
    y1: 121.13,
    x2: 195.969,
    y2: 57.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84EBD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBFFFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "quiz-empty-state_svg__e",
    x1: 74.899,
    y1: 88.799,
    x2: 48.755,
    y2: 41.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84EBD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBFFFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "quiz-empty-state_svg__f",
    x1: 80.472,
    y1: 217.121,
    x2: 45.854,
    y2: 153.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84EBD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBFFFB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "quiz-empty-state_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(41.32 50.85)",
    d: "M0 0h180.155v180.155H0z"
  })))));
};
export default SvgQuizEmptyState;